export default __webpack_public_path__ + "static/media/tech-news-java.360a1886.jpg";